import { useEffect, useState } from "react";
import { RiDownload2Fill, RiEyeFill } from "react-icons/ri";
import PreviewModal from "./previewModal";
import { useTranslation } from "react-i18next";
import { t } from "i18next";
const DownloadPdfComponent = ({ pdfData }) => {
    const [loading, setLoading] = useState(true);

    return (
        <div className='grid grid-cols-2 place-items-center w-full px-10'>
            <div className='w-full flex justify-center'>
                <a
                    href={`data:application/pdf;base64,${pdfData.doc}`}
                    download={pdfData.title + ".pdf"}
                    disabled={loading}
                    className='bg-gray-100 w-full max-w-[80%] flex items-center justify-center py-7 rounded-md'
                >
                    <RiDownload2Fill />
                </a>
            </div>

            <div className='w-full'>{pdfData.title}</div>
        </div>
    );
};
const DocumentPreview = ({ title, data }) => {
    const [openModal, setOpenModal] = useState(false);
    const [displayData, setDisplayData] = useState("");

    const handleClose = () => {
        setOpenModal(false);
    };
    const handleOpenModal = (dataToDisplay) => {
        setDisplayData(dataToDisplay);
        setOpenModal(true);
    };
    const { t } = useTranslation();
    return (
        <div className='rounded-md overflow-clip w-full shadow-lg h-full min-h-[200px] flex flex-col'>
            <div className='flex bg-MetallicBlue px-10 py-4 text-white'>
                <p>{t(title)}</p>
            </div>
            <PreviewModal
                open={openModal}
                handleClose={handleClose}
                data={displayData}
            />
            <div className='hidden md:flex md:flex-col bg-white justify-center items-center gap-5 flex-1 py-5'>
                {data?.map((item) => (
                    <div className='grid grid-cols-2 place-items-center w-full px-10'>
                        <div className='w-full flex justify-center'>
                            <button
                                type='button'
                                onClick={() => handleOpenModal(item?.doc)}
                                className='bg-gray-100 w-full max-w-[80%] flex items-center justify-center py-7 rounded-md'
                            >
                                <RiEyeFill />
                            </button>
                        </div>
                        <div className='w-full'>{item.title}</div>
                    </div>
                ))}
            </div>
            <div className='flex flex-col md:hidden bg-white justify-center items-center gap-5 flex-1 py-5'>
                {data?.map((item) => (
                    <DownloadPdfComponent pdfData={item} />
                ))}
            </div>
        </div>
    );
};

export default DocumentPreview;
